<ng-container *ngIf="article">
  <nz-modal
    [(nzVisible)]="isModalVisible"
    (nzOnOk)="handlePreviewCancel()"
    (nzOnCancel)="handlePreviewCancel()"
    (nzAfterOpen)="onModalFullyVisible()"
    nzWidth="746px"
    nzWrapClassName="announcement-custom-modal"
  >
    <div class="announcement-custom-modal-type">{{ article.annTypeName }}</div>
    <div class="announcement-custom-modal-title">{{ article.title }}</div>
    <div class="announcement-custom-modal-time">
      <span>{{ formatDate(article.publishTime) }}</span>
    </div>

    <div class="announcement-custom-modal-body">
      <nz-spin [nzSpinning]="!article.content">
        <div
          class="announcement-custom-modal-body-content"
          [innerHTML]="article.content | safeHtml"
        ></div>
      </nz-spin>
    </div>
  </nz-modal>
</ng-container>
